import React, { useEffect } from 'react';
import { usePrimeModel } from '../../contexts/PrimeModelContext';
import styles from './PrimeModelSummary.module.css';

const PrimeModelSummary: React.FC = React.memo(
  () => {
    const { modelData, resetModel } = usePrimeModel();

    useEffect(() => {
      console.log('[PrimeModelSummary] Mounted');
      return () => console.log('[PrimeModelSummary] Unmounted');
    }, []);

    useEffect(() => {
      console.log('[PrimeModelSummary] modelData changed:', {
        hasData: !!modelData,
        artifactId: modelData?.artifact?.id,
        artifactName: modelData?.artifact?.name,
        statesCount: modelData?.states.length,
        transitionsCount: modelData?.transitions.length,
        processesCount: modelData?.processes.length,
      });
    }, [modelData]);

    if (!modelData) {
      return <div>No model data available</div>;
    }

    return (
      <div className={styles.modelSummary}>
        <h2>Model Summary</h2>
        <div className={styles.summaryContent}>
          <div className={styles.artifactSummary}>
            <h3>Artifact</h3>
            <p>
              <strong>Name:</strong> {modelData.artifact.name}
            </p>
            <p>
              <strong>ID:</strong> {modelData.artifact.id}
            </p>
          </div>
          <div className={styles.statesSummary}>
            <h3>States</h3>
            <p>
              <strong>Count:</strong> {modelData.states.length}
            </p>
          </div>
          <div className={styles.transitionsSummary}>
            <h3>Transitions</h3>
            <p>
              <strong>Count:</strong> {modelData.transitions.length}
            </p>
          </div>
          <div className={styles.processesSummary}>
            <h3>Processes</h3>
            <p>
              <strong>Count:</strong> {modelData.processes.length}
            </p>
          </div>
        </div>
        <button onClick={resetModel}>Start New Model</button>
      </div>
    );
  },
  (_prevProps, _nextProps) => {
    return true;
  }
);

PrimeModelSummary.displayName = 'PrimeModelSummary';

export default PrimeModelSummary;
